import { render } from "./AppExtensions.vue?vue&type=template&id=a61eff54"
import script from "./AppExtensions.vue?vue&type=script&lang=js"
export * from "./AppExtensions.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__